"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidebarWidth = exports.sidebarShrinkWidth = exports.sidebarHeight = exports.headerHeight = exports.footerHeight = void 0;
var headerHeight = 60;
exports.headerHeight = headerHeight;
var footerHeight = 50;
exports.footerHeight = footerHeight;
var sidebarWidth = 240;
exports.sidebarWidth = sidebarWidth;
var sidebarShrinkWidth = 45;
exports.sidebarShrinkWidth = sidebarShrinkWidth;
var sidebarHeight = 60; // Mobile mode
exports.sidebarHeight = sidebarHeight;